import React from 'react'
// types
import { Classes } from 'jss'
// components
import NotificationTitle from 'pages/Notifications/NotificationTitle'
// styles
import injectSheet from 'react-jss'
import { sheet } from './sheet'
// icons
import Email from 'components/svgComponent/notification/Email'
// utils
import cx from 'classnames'

interface Props {
  classes: Classes
  title: string
  text: string
  viewedAt: boolean
  createdAt: string
}

const Index = ({ classes, title, text, viewedAt, createdAt }: Props) => {
  return (
    <div className={cx(classes.main, { [classes.unread]: viewedAt })}>
      <Email />
      <div className={classes.root}>
        <NotificationTitle title={title} />
        <p className={classes.text}>{text}</p>
      </div>
      <p className="createdAt">{createdAt}</p>
    </div>
  )
}

export default injectSheet(sheet)(Index)
